import React, { useCallback, useEffect, useState } from "react";
import { Box, Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import libphonenumber from "google-libphonenumber";

import { PASSWORD_REGEX } from "@utils/constants";
import { INIT_USER_REGISTRATION_DATA } from "../../constants";
import UserRegistrationForm from "./UserRegistrationForm";
import {
  VERTIFICATION_METHOD_ENUM,
  REGISTRATION_PROCCESS_STEPS,
} from "../../constants";

import VertificationMethodSelection from "./vertification/VertificationMethodSelection";
import EmailVertification from "./vertification/EmailVertification";
import OTPVertification from "./vertification/OTPVertification";
import SubmitButton from "../submit-button/SubmitButton";
import BackButton from "../submit-button/BackButton";
import { SectionContainer } from "../styled/StyledComponents";
import Oops from "./vertification/Oops";
import SuccessfulVerification from "./vertification/SuccessfulVerification";

import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { signup, setUser } from "@reducers/auth";
import { setUpRecaptcha, sendOTP, verifyPhoneNumber } from "@services/auth";
import { authStorage } from "@services/authStorage";
import { parsePhoneNumber } from "libphonenumber-js";
import { useDispatch } from "react-redux";
import { updateUserProfile } from "../../../../services/auth";
import LoadingIndicator from "@components/LoadingIndicator";
import toastr from "toastr";
import { AmptitudeEvents } from "@services/amptitude_events";
import { USER_DETAILS_ENTERED } from "@services/amptitude_contants";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
    marginBottom: 60,
  },
  userRegistration: {
    color: "#E77228",
    padding: 40,
    fontSize: 27,
    fontWeight: 400,
  },
}));

const phoneRegExp =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(
      /^'?\p{L}+(?:[' ]\p{L}+)*'?$/u,
      "Not allowed to use special characters"
    )
    .test(
      "invalidFirstName",
      "First name must not be empty",
      function (firstName) {
        if (firstName) return Boolean(firstName.trim());
        return true;
      }
    )
    .required("*This is required"),
  lastName: Yup.string()
    .matches(
      /^'?\p{L}+(?:[' ]\p{L}+)*'?$/u,
      "Not allowed to use special characters"
    )
    .test(
      "invalidLastName",
      "Last name must not be empty",
      function (lastName) {
        if (lastName) return Boolean(lastName.trim());
        return true;
      }
    )
    .required("*This is required"),
  email: Yup.string()
    .email("*Must be a valid email address")
    .max(100, "*Email must be less than 100 characters")
    .required("*This is required"),
  country: Yup.mixed(),
  phoneNumber: Yup.string()
    .test("invalidPhone", "*Phone number is invalid", function (phoneNumber) {
      if (this.parent.country && phoneNumber) {
        const { countryCode } = this.parent.country || {};
        try {
          if (
            !phoneUtil.isValidNumberForRegion(
              phoneUtil.parse(phoneNumber, countryCode),
              countryCode
            )
          ) {
            return false;
          }
        } catch (error) {
          return false;
        }
      }
      return true;
    })
    .matches(phoneRegExp, "*Phone number is invalid")
    .required("*This is required"),
  password: Yup.string()
    .matches(
      PASSWORD_REGEX,
      "*Password must be minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character"
    )
    .required("*This is required"),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("password"), null],
      "*Password and Confirm Password must be match"
    )
    .matches(
      PASSWORD_REGEX,
      "*Confirm Password must be minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character"
    )
    .required("*This is required"),
  agree: Yup.bool().oneOf([true], "*This is required"),
  isReceiveEmail: Yup.bool(),
});

const smsButtonId = "sms-button";

export default function UserRegistrationContainer({
  countries,
  onNextStep,

  isEditProfile,
  setIsEditProfile,
  registrationStep,
  setRegistrationStep,
  vertificationMethod,
  setVertificationMethod,
}) {
  const classes = useStyles();
  INIT_USER_REGISTRATION_DATA.country = countries.find(
    (c) => c.countryCode === "GB"
  );

  const [isClickedSmsVerifyButton, setIsClickedSmsVerifyButton] =
    useState(false);
 

  const [isSmsSelected,setIsSmsSelected]=useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [sessionInfo, setSessionInfo] = useState();

  const user = useSelector((state) => state.auth.user);

  const router = useRouter();
  const { isVerified, token } = router.query || {};
  const isVerifiedUser = user?.isVerified || isVerified === "true";
  const isVerifyFail = isVerified === "false";
  const dispatch = useDispatch();

  const {
    control,
    formState: { errors, isValid, isDirty },
    handleSubmit,
    watch,
    setValue,
    setError,
    reset,
  } = useForm({
    mode: "all",
    defaultValues: INIT_USER_REGISTRATION_DATA,
    resolver: yupResolver(validationSchema, {
      stripUnknown: true,
      abortEarly: false,
    }),
  });

  const watchCountry = watch("country");



  // If user registerd an account but have not verified yet then we stay at select verification method screen
  // If user registed an account and verify successfully then we redirect to successful screen
  useEffect(() => {
    if (user?.id && !isVerifiedUser) {
    
      setRegistrationStep(REGISTRATION_PROCCESS_STEPS.step2);
    }
    if (isVerifiedUser) {
      setRegistrationStep(REGISTRATION_PROCCESS_STEPS.step2);
      setVertificationMethod(VERTIFICATION_METHOD_ENUM.SUCCESSFUL_VERIFICATION);
      authStorage.token = token;
    }
  }, [user]);

  // If user registered an account and user back to step1 to update their info
  useEffect(() => {
    if (user?.id && registrationStep === REGISTRATION_PROCCESS_STEPS?.step1) {
      initUserInfo(user);
    }
  }, [user, registrationStep]);

  // If verify email fail we stay at step2 and fail verification screen
  useEffect(() => {
    if (isVerifyFail) {
      setRegistrationStep(REGISTRATION_PROCCESS_STEPS.step2);
      setVertificationMethod(VERTIFICATION_METHOD_ENUM.FAIL_VERIFICATION);
    }
  }, [isVerifyFail]);

  const initUserInfo = (user) => {
    const {
      firstName,
      lastName,
      email,
      country,
      phoneNumber,
      isReceiveEmail,
      password,
      confirmPassword,
    } = user;

    const data = {
      firstName,
      lastName,
      email,
      country: countries?.find((c) => c.geonameId === country.code),
      phoneNumber: phoneNumber?.split(`+${watchCountry?.phone}`)[1],
      password: password || "",
      confirmPassword: confirmPassword || "",
      agree: true,
      isReceiveEmail,
    };
    reset(data);
  };

  const newSignup = async (user) => {
    if (user) {
      const response = await AmptitudeEvents(
        "User Registration",
        user?.id,
        USER_DETAILS_ENTERED,
        "/login"
      );
    }
    return dispatch(signup(user));
  };

  const onRegisterUser = async (data) => {
    setIsLoading(true);
    const { phoneNumber } = data;

    const { isSuccess, errorCode } = await newSignup({
      ...data,
      phoneNumber: parsePhoneNumber(phoneNumber, data?.country?.countryCode)
        .number,
    });

    if (user) {
      const response = await AmptitudeEvents(
        "User Registration",
        user?.id,
        USER_DETAILS_ENTERED,
        "/login"
      );
    }

    if (isSuccess) {
      setRegistrationStep(REGISTRATION_PROCCESS_STEPS.step2);
    } else {
      if (errorCode === "USER-0004") {
        setError("email", {
          type: "custom",
          message: "*Email is existed",
        });
      } else if (errorCode === "USER-0008") {
        setError("phoneNumber", {
          type: "custom",
          message: "*Phone number is existed",
        });
      }
    }

    setIsLoading(false);
  };

  const onUpdateProfile = async (data) => {
    setIsLoading(true);
    const { isReceiveEmail, phoneNumber, ...restData } = data;

    const { isSuccess, user, errorCode } = await updateUserProfile({
      ...restData,
      phoneNumber: parsePhoneNumber(phoneNumber, data?.country?.countryCode)
        .number,
    });

    if (user) {
      const response = await AmptitudeEvents(
        "User Registration",
        user?.id,
        USER_DETAILS_ENTERED,
        "/login"
      );
    }

    if (isSuccess) {
      dispatch(
        setUser({
          ...user,
          password: data?.password || "",
          confirmPassword: data?.confirmPassword || "",
        })
      );
      setIsEditProfile(false);
      setRegistrationStep(REGISTRATION_PROCCESS_STEPS.step2);
    } else {
      if (errorCode === "USER-0004") {
        setError("email", {
          type: "custom",
          message: "*Email is existed",
        });
      } else if (errorCode === "USER-0008") {
        setError("phoneNumber", {
          type: "custom",
          message: "*Phone number is existed",
        });
      }
    }

    setIsLoading(false);
  };

  const onSendOTP = (userData, cb) => {
    setIsLoading(true);

    const {
      phoneNumber,
      country: { countryCode: code },
    } = userData;
   if(!isSmsSelected){
    setUpRecaptcha({ buttonId: smsButtonId });
   }
   setIsSmsSelected(true)
    sendOTP({
      phone: parsePhoneNumber(phoneNumber, code).number,
      ifSuccess: ({ verificationId }) => {
        setSessionInfo(verificationId);
        setVertificationMethod(VERTIFICATION_METHOD_ENUM.SMS);
        setIsLoading(false);
        cb && cb(false);
      },
      ifFailed: (err) => {
        toastr.error(err.message);
        setIsLoading(false);
        return cb && cb(false);
      },
    });
  };

  const onResendOTP = (userData) => {
    const {
      phoneNumber,
      country: { countryCode: code },
    } = userData;
    sendOTP({
      phone: parsePhoneNumber(phoneNumber, code).number,
      ifSuccess: ({ verificationId }) => {
        setSessionInfo(verificationId);
      },
      ifFailed: (err) => {
        toastr.error(err.message);
      },
    });
  };

  const onVerifyOTP = async (OTP) => {
    setIsLoading(true);
    setIsClickedSmsVerifyButton(true);
    try {
      const response = await verifyPhoneNumber({
        code: OTP,
        sessionInfo,
      });
      const { user } = response || {};
      dispatch(setUser(user));
      setVertificationMethod(VERTIFICATION_METHOD_ENUM.SUCCESSFUL_VERIFICATION);
    } finally {
      setIsLoading(false);
    }
  };

  const onSelectVertificationMethod = (method) => {
    setVertificationMethod(method);
  };



  const renderVertificationScreen = useCallback(() => {
    switch (vertificationMethod) {
      case VERTIFICATION_METHOD_ENUM.EMAIL:
        return <EmailVertification user={user} />;
      case VERTIFICATION_METHOD_ENUM.SMS:
        return (
          <OTPVertification
            user={user}
            onSubmit={onVerifyOTP}
            onResendOTP={onResendOTP}
            isLoading={isLoading}
          />
        );
      case VERTIFICATION_METHOD_ENUM.SUCCESSFUL_VERIFICATION:
        return (
          <SuccessfulVerification
            userData={user}
            isClickedSmsVerifyButton={isClickedSmsVerifyButton}
            token={token}
          />
        );
      case VERTIFICATION_METHOD_ENUM.FAIL_VERIFICATION:
        return <Oops user={user} />;
      default:
        return (
          <VertificationMethodSelection
            onSelectVertificationMethod={onSelectVertificationMethod}
            setRegistrationStep={setRegistrationStep}
            setIsEditProfile={setIsEditProfile}
            onSendOTP={onSendOTP}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
    }
  }, [vertificationMethod]);




  return (
    <>
      <Box className={classes.root} component="section">
        {registrationStep === REGISTRATION_PROCCESS_STEPS.step1 && (
          <SectionContainer>
            <UserRegistrationForm
              control={control}
              errors={errors}
              watchCountry={watchCountry}
              countries={countries}
              setValue={setValue}
              isHideCheckbox={isEditProfile}
            />
            <Grid
              style={{ padding: 40, display: "flex",justifyContent:"flex-end" }}
              spacing={2}
              container
            >
              {/* <Grid item xs={6}>
                <a style={{ textDecoration: "none" }} href="/login">
                  {" "}
                  <BackButton>Back</BackButton>
                </a>
              </Grid> */}
              <Grid item xs={6}>
                <SubmitButton
                  onClick={
                    isEditProfile
                      ? handleSubmit(onUpdateProfile)
                      : handleSubmit(onRegisterUser)
                  }
                  disabled={!isValid || !isDirty || isLoading}
                >
                  Next
                </SubmitButton>
              </Grid>
            </Grid>
          </SectionContainer>
        )}
        {registrationStep === REGISTRATION_PROCCESS_STEPS.step2 &&
          renderVertificationScreen()}
      </Box>
      <LoadingIndicator loading={isLoading} />
      <Button id={smsButtonId} style={{ display: "none" }} />
    </>
  );
}
